import axios from '../utils/axios'
// --一元包邮--
// 已登录
export function onePackage (data) {
  return axios({
    url: '/Sale/Sale/OnePackage',
    method: 'post',
    data: data
  })
}
// 未登录
export function noLoginOnePackage (data) {
  return axios({
    url: '/NoAuth/SaleIndex/OnePackageNoLogin',
    method: 'post',
    data: data
  })
}
// --二级类目--
// 已登录
export function Leve2NameList (query) {
  return axios({
    url: '/Sale/Sale/Leve2NameList',
    method: 'get',
    params: query
  })
}
// 未登录
export function Leve2NameListNoLogin (query) {
  return axios({
    url: '/NoAuth/SaleIndex/Leve2NameList',
    method: 'get',
    params: query
  })
}
// 配置区域金额
export function RegionalAmount () {
  return axios({
    url: '/NoAuth/SaleIndex/RegionalAmount',
    method: 'get'
  })
}
